import initializeJsonFromLocalStorage from "../../../utils/storage/initialize-storage-utils";
import { getLinks } from "../../../services/external-link-management/external-link-management.js";
import { getGratifications } from "../../../services/gratification/gratification-service.js";


const linksExternal = {
  state: {
    linksExternalData: initializeJsonFromLocalStorage("links-external"),
    gratification: false
  },
  mutations: {
    setLinksExternalData(state, data) {
      state.linksExternalData = data;
    },
    clear(state) {
      state.linksExternalData = null;
    },
    gratification(state, valor) {
      state.gratification = valor;
    },
  },
  actions: {
    async checkGratifications({ commit }, competenceYear) {
      try {
        const data = await getGratifications(competenceYear);
        const hasGratification = data && data.length > 0;
        commit("gratification", hasGratification);
        return hasGratification;
      } catch (err) {
        commit("gratification", false);
        throw err;
      }
    },
    requestLinksExternalData({ commit }) {
      return new Promise((resolve, reject) => {
        getLinks()
          .then((linksExternal) => {
            localStorage.setItem("links-external", JSON.stringify(linksExternal));
            commit("setLinksExternalData", linksExternal);
            resolve(linksExternal);
          })
          .catch((err) => {
            console.error("requestLogin error: ", err);
            reject(err);
          });
      });
    },
    setStoreLinksExternalData({ commit }, data) {
      localStorage.setItem("links-external", JSON.stringify(data));
      commit("setLinksExternalData", data);
    },
    clearlinksExternalData({ commit }) {
      return new Promise((resolve, reject) => {
        try {
          localStorage.setItem("links-external", "");
          commit("clear");
          resolve();
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  getters: {
    getLinksExternalData: (state) => state.linksExternalData,
    getGratification: (state) => state.gratification,
  },
};

export default linksExternal;
